import { LOAD } from 'model/oneTimePasscodeEvent';
import { load } from 'sdk/oneTimePasscodeEvent';
import { takeEvery } from 'redux-saga/effects';
import { callAction, ORM } from '../util';

export default function* saga() {
  yield takeEvery(
    LOAD.ACTION,
    callAction({
      api: load,
      dataName: ORM,
      type: LOAD,
    })
  );
}
